import {
    filter,
    pluck,
    distinctUntilChanged,
    debounceTime,
    mapTo,
} from 'rxjs/operators';

import ErrorTypes from '../../Errors/Constants/Error.type';

const BUFFERING_ROTATION_TRIGGER_IN_MS = 8000;

const excessiveBufferingError = {
    type: ErrorTypes.EXCESSIVE_BUFFERING,
    data: {
        duration: BUFFERING_ROTATION_TRIGGER_IN_MS,
    },
};

const createExcessiveBufferingStream = (
    playerPlaybackUpdate$,
    scheduler,
) =>
    playerPlaybackUpdate$
        .pipe(
            pluck('playbackStatus'),
            distinctUntilChanged(),
            debounceTime(BUFFERING_ROTATION_TRIGGER_IN_MS, scheduler),
            filter(playbackStatus => playbackStatus === 'BUFFERING'),
            mapTo(excessiveBufferingError)
        );

export default createExcessiveBufferingStream;
